<template>
    <MapLeaflet />
</template>
<script setup>
import { defineAsyncComponent } from "vue";
const MapLeaflet = defineAsyncComponent(() => import("../lazy/MapLeaflet.vue"));
</script>
